module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACoSURBVHgBlVLBDcMgEOO4BbJKJ4BN2k2ADTpCO0Z/YYKu0xfUl4oKXUBR/LIO2zoMxgAhhMUcoGlICDO/a61P8DgSp5Rkfi2lXDjn/HHOLdba6L2nFdBiIgoIvIO/WIbQZJiMNjUxkiOQtpX6NAyDmJD2O1TinaE3CddigdUGpNKIN/DogpKMtdZRETwSyxqzInjWxqy9/8NB/NAX7ItA4E0ebhuc+Rpfw2KEG7aX4bQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cross.png
// module id = 4711
// module chunks = 1